import React from "react";

interface CompactLoaderButtonProps {
  text: string;
  onClick: any;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading: boolean;
  /** Optional image shown to the left of the label (hidden while loading). */
  leadingIconSrc?: string;
  leadingIconAlt?: string;
}

const CompactLoaderButton: React.FC<CompactLoaderButtonProps> = ({
  text,
  onClick,
  type = "button",
  disabled = false,
  isLoading,
  leadingIconSrc,
  leadingIconAlt = "",
}) => {
  const disabledStyles = "opacity-50 cursor-not-allowed bg-black";

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter") {
      onClick();
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={`inline-flex shrink-0 items-center justify-center gap-2 px-3 py-1.5 min-h-[2.25rem] max-w-[min(100vw-6rem,280px)] rounded-md bg-purple text-white text-13 font-semibold hover:bg-culightpurple ${
        isLoading ? disabledStyles : ""
      }`}
      disabled={disabled}
    >
      {isLoading ? (
        <svg
          className="animate-spin h-4 w-4 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
      ) : (
        <>
          {leadingIconSrc ? (
            <img
              src={leadingIconSrc}
              alt={leadingIconAlt}
              className="h-5 w-5 shrink-0 object-contain"
              aria-hidden={leadingIconAlt === ""}
            />
          ) : null}
          <span className="text-center leading-snug">{text}</span>
        </>
      )}
    </button>
  );
};

export default CompactLoaderButton;
